import { Layers } from '../models/layers.enum';
import { MapLayerRenderer } from '../mapbox-map-layer-renderer';
import { LineLayerOptions, IconLayerOptions } from '../models';
import { Theme } from 'src/app/modules/shared/models';
import { MapboxHelper } from '../mapbox-map-helper';
import { CircleLayerOptions } from '../models/circle-layer-options';

export class RenderDrawRouteLayer extends MapLayerRenderer {
    constructor(
        protected _mapboxHelper: MapboxHelper,
        private _theme: Theme = Theme.Light
    ) {
        super(_mapboxHelper);
    }

    protected modifyFeatureCollection(fc: GeoJSON.FeatureCollection): GeoJSON.FeatureCollection {
        return fc;
    }

    protected renderLayers(map: mapboxgl.Map): void {
        const layers = {};
        layers[Layers.DrawRoute] = [];

        const layerId = `${Layers.DrawRoute}`;
        if (!this._mapboxHelper.layerExists(map, layerId)) {
            let layerNames = [];
            const options = this._shapeOptions();
            layerNames = this._mapboxHelper.renderLineLayer(map, this._sourceId, this._sourceLayer, layerId, options);
            layers[Layers.DrawRoute] = layers[Layers.DrawRoute].concat(layerNames);
        }

        const pointLayerId = `${Layers.DrawRoute}-point`;
        if (!this._mapboxHelper.layerExists(map, pointLayerId)) {
            let layerNames = [];
            const options = this._pointOptions();
            layerNames = this._mapboxHelper.renderCircle(map, this._sourceId, this._sourceLayer, pointLayerId, options);
            layers[Layers.DrawRoute] = layers[Layers.DrawRoute].concat(layerNames);
        }

        const refpointLayerId = `${Layers.DrawRoute}-refpoint`;
        if (!this._mapboxHelper.layerExists(map, refpointLayerId)) {
            let layerNames = [];
            const options = this._startPoints();
            layerNames = this._mapboxHelper.renderCircle(map, this._sourceId, this._sourceLayer, refpointLayerId, options);
            layers[Layers.DrawRoute] = layers[Layers.DrawRoute].concat(layerNames);
        }

        this.addLayerNames(layers);
    }

    //#region rendering options for layers connected to log
    private _shapeOptions(): LineLayerOptions {
        const options = new LineLayerOptions();
        options.color = this._theme === Theme.Light ? '#fbb03b' : '#fbb03b';

        options.color = [
            'case',
            ['==', ['get', 'mode'], 'view'],
            '#fbb03b',
            ['==', ['get', 'mode'], 'selected'],
            '#39a935',
            this._theme === Theme.Light ? '#fbb03b' : '#fbb03b'
        ];

        options.lineWidth = 2;
        options.opacity = 1;
        options.dashed = true;

        options.dashedWidth = [
            'case',
            ['==', ['get', 'type'], 'reference'],
            ['literal', [0.2, 2]],
            ['literal', [1]]
        ];

        return options;
    }

    private _pointOptions(): CircleLayerOptions {
        const options = new CircleLayerOptions();
        options.visibility = true;
        options.color = '#fbb03b';
        options.radius = 4;
        options.strokeOpacity = 0.8;
        options.strokeWidth = 2;
        options.strokeColor = '#ffffff';
        options.customFilters = [['all', ['==', 'type', 'checkpoint']]];

        return options;
    }

    private _startPoints(): CircleLayerOptions {
        const options = new CircleLayerOptions();
        options.visibility = true;
        options.color = ['case',
            ['has', 'color'],
            ['get', 'color'],
            '#ffffff'
        ];

        options.radius = 6;
        options.strokeOpacity = 0.8;
        options.strokeWidth = 2;
        options.strokeColor = '#ffffff';
        options.customFilters = [['all', ['==', 'type', 'refpoint']]];

        return options;
    }
    //#endregion
}
